import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsSansLivreur } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsSansLivreur from '@/features/commands/components/extensions/commands-sans-livreurs'

export const Route = createFileRoute('/_authenticated/commands-sans-livreur/')({
  component: () => {
    const { t } = useTranslation()
    return (
      <CommandsSansLivreur
        queryExtension={{
          querykey: 'sans-livreur',
          title: t('sidebar.commandes-sans-livreur'),
          initialFilter: [
            {
              id: 'trash',
              value: false,
            },
            {
              id: 'is_ramassed',
              value: true,
            },
          ],
          queryFn: getCommandsSansLivreur,
        }}
      />
    )
  },
  validateSearch: validateCommandsPageSearchParams,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes sans livreur`,
      },
    ],
  }),
})

// function decodeFromBinary(str: string): string {
//   return decodeURIComponent(
//     Array.prototype.map
//       .call(atob(str), function (c) {
//         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
//       })
//       .join('')
//   )
// }

// function encodeToBinary(str: string): string {
//   return btoa(
//     encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
//       return String.fromCharCode(parseInt(p1, 16))
//     })
//   )
// }
